import {
    MODULEMASTERLISTFORADMIN_SUCCESS,
    MODULEMASTERLISTFORADMIN_FAILED,
    RESET_MODULEMASTERLISTFORADMIN,
    LOADING_MODULEMASTERLISTFORADMIN,
    NETWORK_ERROR_MODULEMASTERLISTFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetModuleMasterAdminList = () => {
    return { type: RESET_MODULEMASTERLISTFORADMIN };
};

const moduleMasterAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_MODULEMASTERLISTFORADMIN });
    await adminServices
        .post("ModulemasterListforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(ModuleMasterAdminListsuccess(res.data));
                    break;
                default:
                    dispatch(ModuleMasterAdminListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_MODULEMASTERLISTFORADMIN,
                payload: err
            });
        });
};


function ModuleMasterAdminListsuccess(data) {
    return {
        type: MODULEMASTERLISTFORADMIN_SUCCESS,
        payload: data
    };
}
function ModuleMasterAdminListFailed(data) {
    return {
        type: MODULEMASTERLISTFORADMIN_FAILED,
        payload: data
    };
}

export { moduleMasterAdminLists, resetModuleMasterAdminList }